import React, { useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Config } from "../../Config";
import { emptyCart, updateCartData } from "../../Redux/Actions";
import PaymentFailImage from "../../assets/images/paymentFail.svg";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import "./PaymentFail.scss";
import "./Responsive.scss";

const PaymentAccept = (props) => {
  let timer;
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const breadCrumbData = [{ title: "خانه", link: "/" }];

  useEffect(() => {
    Config.pageUp();
    checkOrdersAfterBankReturn();
    timer = setTimeout(() => {
      props.history.replace("/");
    }, 30000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const doDisptchUpdateData = (result, status) => {
    if (status === 200) {
      const cartOrderDetails = result.data.data.orderDetail;
      let obj = [];
      cartOrderDetails.map((item) => {
        obj.push({
          id: item.productId,
          image: item.image,
          description: "",
          name: item.title,
          price: item.price,
          weight: "",
          pageCount: "",
          orderDetailId: item.orderDetailId,
          count: item.count,
        });
      });
      dispatch(updateCartData(obj));
    } else if (status === 404) {
      dispatch(emptyCart(cart));
    }
  };

  const checkOrdersAfterBankReturn = () => {
    let myHeaders = new Headers();
    user[0]?.token && myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/orders/showorder", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 200) {
          doDisptchUpdateData(result, 200);
        } else if (result.status == 404) {
          doDisptchUpdateData(result, 404);
        } else {
          toast.error(<div>{result.data.messages}</div>);
          dispatch(emptyCart(cart));
        }
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <section className="paymentWrapper mobile">
      <Helmet>
        <title>{Config.helmetTitle} | پرداخت ناموفق</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="paymentContents">
        <div className="desktop">
          <div className="paymentFigure">
            <img src={PaymentFailImage} className="paymentImage" alt="پرداخت ناموفق" />
            <p className="paymentTitle">متاسفانه پرداخت شما ناموفق بود!</p>
            <Link className="return" to="/">
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(withRouter(PaymentAccept));
